import {MenuPage} from "../../../shared-gen/Model/Menus/MenuPage";

export class MenuPageFun {

	static createNew(columns: number = 4): MenuPage {
		return {
			Name: '',
			Columns: columns,
			Cells: []
		};
	}

}
